import { z } from 'zod';

/** Schema do formulário de BYOK (cadastro/rotação). Mensagens são chaves
 * i18n (regra §5.3). modelId e nickname são opcionais. */
export const byokFormSchema = z.object({
  providerId: z.string().uuid('ai-clinic:byok.form.validation.providerRequired'),
  apiKey: z.string().trim().min(8, 'ai-clinic:byok.form.validation.apiKeyTooShort'),
  modelId: z.string().trim().max(200).optional().default(''),
  nickname: z.string().trim().max(120).optional().default(''),
});

export type ByokFormInput = z.infer<typeof byokFormSchema>;
